import { render, staticRenderFns } from "./CalculatedPrice.vue?vue&type=template&id=b7aec794&scoped=true&"
import script from "./CalculatedPrice.vue?vue&type=script&lang=js&"
export * from "./CalculatedPrice.vue?vue&type=script&lang=js&"
import style0 from "./CalculatedPrice.vue?vue&type=style&index=0&id=b7aec794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aec794",
  null
  
)

export default component.exports